export default  {
    component: 'generation_source',
    name: 'generation_source',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Module',
        param: 'module',
        type: 'text',
        required: true,
        identifier: true,
        description: `> Two module need to be configured as mentioned below:
        - **home**
        - **inverter**`
      },
      {
        name: 'Source',
        param: 'source',
        type: 'text',
        description: `Source are as follows:
        - inverter
        - em
        - mfm`
      },
      {
        name: 'Ref Device ID',
        param: 'ref_device_id',
        type: 'number',
        description: `If source is added as em or mfm, you need to add block/device reference
        - e.g [1-1]`
      },
      {
        name: 'Parameter List',
        param: 'parameterList',
        type: 'text',
        description: `> If Module is:
        - home (if plant has wms) : {"inverter":{"param":["energy","pr","ac_yield","ac_power"]},"weather station":{"param":["poa_insolation","ghi_insolation"]}}
        - home (if plant does not have wms) : {"inverter":{"param":["energy","pr","ac_yield","ac_power"]}}
        - inverter (if plant has wms) : {"weather station":{"param":["irradiance_vertical"]}}
        - inverter (if plant does not have wms) : do not add anything`
      }
    ]
  }